import type { FakeZendeskLogViewerComponentProps } from './FakeZendeskLogViewerComponent';

export const FakeZendeskLogViewerComponent = {
    MountAsync: async (target: HTMLElement, props: FakeZendeskLogViewerComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { FakeZendeskLogViewerComponent } = await import('./FakeZendeskLogViewerComponent');
        return await mountReactComponentAsync(target, FakeZendeskLogViewerComponent, props);
    }
};
